export enum RouteWrapperVariant {
  firstLevel = "firstLevel",
  unauthenticatedRoute = "unauthenticatedRoute",
  unauthenticatedRouteWithBackButton = "unauthenticatedRouteWithBackButton",
  productDetail = "productDetail",
  practiceDetail = "practiceDetail",
  fullScreen = "fullScreen",
  fullScreenWithCloseButton = "fullScreenWithCloseButton",
  secondLevelWithTitleAndAiAssistant = "secondLevelWithTitleAndAiAssistant",
  secondLevelWithTitleAndAiAssistantFullHeight = "secondLevelWithTitleAndAiAssistantFullHeight",
  fullScreenWithHeaderAndCloseButton = "fullScreenWithHeaderAndCloseButton",
  fullScreenWithHeaderAndCloseModal = "fullScreenWithHeaderAndCloseModal",
  upgradePage = "upgradePage",
  profileData = "profileData",
  profile = "profile",
}
